<template>
  <v-flex class="admin-page" >
    <admin-mission-plan-template :itemid="itemid" />
  </v-flex>
</template>
<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'
import { SecurityItemsKeys } from '@/enum/SecurityItems'
import AdminMissionPlanTemplate from '@/components/admin/missionPlanTemplate/AdminMissionPlanTemplate.vue'


  
@Component({
  name: 'Planning', 
  components:{AdminMissionPlanTemplate},
  props:{
    itemid:{
      type:Number
    }
  }  
})
export default class Planning extends Vue {      

  /*beforeRouteEnter(to:any,from:any,next:any) {        
     next((vm:Planning) => {              
       next((vm.$store.myGetters.userSecurity[SecurityItemsKeys.].enable || 
             vm.$store.myGetters.userSecurity[SecurityItemsKeys.HOME_VIEW_DATA].enable)?'':'/login')
     })
  }*/

  mounted(){
    this.$vuetify.theme.primary = '#FB8C00'
    this.$vuetify.theme.secondary = '#4066aa'    
  }
  
}
</script>